import { Button, Grid, Paper, Typography, Stack } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useEffect } from "react";
import { trackEvent } from "src/Amplitude";

export default function UKOnboardingSuccess() {
  useEffect(() => {
    trackEvent("UK Onboarding Success Viewed", {}, "Onboarding");
  }, []);

  return (
    <Grid container spacing={3} mt={2}>
      <Grid item xs={12}>
        <Paper
          elevation={1}
          sx={{
            p: 4,
            borderRadius: 2,
            textAlign: "center",
            backgroundColor: "#E8F5E9",
            border: "2px solid #4CAF50",
          }}
        >
          <CheckCircleOutlineIcon sx={{ fontSize: 80, color: "#4CAF50", mb: 2 }} />
          <Typography variant="h4" fontWeight={600} gutterBottom color="#2E7D32">
            Welcome to Caleb & Brown!
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            Your account has been successfully activated. You can now start trading
            cryptoassets.
          </Typography>
        </Paper>
      </Grid>

      <Grid item xs={12}>
        <Paper elevation={1} sx={{ p: 3, borderRadius: 2 }}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            What's Next?
          </Typography>
          <Stack spacing={2}>
            <Typography variant="body1">
              1. Your account is now fully activated and ready to use.
            </Typography>
            <Typography variant="body1">
              2. You can deposit funds and start trading cryptoassets.
            </Typography>
            <Typography variant="body1">
              3. Remember, only invest money you can afford to lose.
            </Typography>
          </Stack>
        </Paper>
      </Grid>

      <Grid item xs={12}>
        <Stack direction="row" justifyContent="center" mt={2}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => (window.location.href = "/dashboard")}
            sx={{ minWidth: 300 }}
          >
            Go to Dashboard
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
}
